import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { Root } from './Processinglist.css';
import PageTitle from '../Layout/components/PageTitle';
import Client from '../AddClient/components/Client';
import { Paper, Table, TableHead, TableRow, TableCell, TableBody, Button, InputBase, Dialog, Drawer, Tabs, Tab, TableFooter, TablePagination } from '@material-ui/core';
import Search from '@material-ui/icons/Search'
import DeleteForeverIcon from '@material-ui/icons/DeleteForever';
import SideList from '../User/components/SideList'
import { BASE_URL } from '../../store/config';
import instance from '../../request/http'
import { roleStr } from '../../common/common';
import Toast from '../Layout/components/Toast';
import AlertDialog from '../Layout/components/AlertDialog'

const ADD = 0;
const VIEW = 1;
const EDIT = 2;
const CLIENT = 11;
const INDIVIDUAL = "individual";
const CORPORATION = "corporation";
const AUDITED = "audited";
const UNAUDITED = "unaudited";
class ProcessingList extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {
            iClients: [],
            cClients: [],
            open: false,
            stateRight: false,
            dialogTitle: "",
            dialogState: ADD,
            dialogData: null,
            totalUser: [],
            tabIndex: 0,
            client_id: 0,
            searchName: "",

            showToast: false,
            toastMsg: "",
            toastState: "",
            showAlert: false,

            page_index: 1,
            page_size: 5,
            total_items: 0,
        }
        this.handleAddClient = this.handleAddClient.bind(this);
        this.handleChange = this.handleChange.bind(this);
        this.handleView = this.handleView.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.handleDel = this.handleDel.bind(this);
        this.handleCreate = this.handleCreate.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleApply = this.handleApply.bind(this);
        this.handleSearch = this.handleSearch.bind(this);
        this.handleCloseDialog = this.handleCloseDialog.bind(this);
        this.handleCloseToast = this.handleCloseToast.bind(this);
        this.handleAlertYes = this.handleAlertYes.bind(this);
        this.handleAlertNo = this.handleAlertNo.bind(this);
        this.handleChangePage = this.handleChangePage.bind(this);
        this.handleChangeRowsPerPage = this.handleChangeRowsPerPage.bind(this);
    }
    render() {
        const {
            open,
            dialogTitle,
            dialogData,
            dialogState,
            stateRight,
            iClients,
            cClients,
            tabIndex,
            showToast,
            toastMsg,
            toastState,
            showAlert,
            page_index,
            page_size,
            total_items,
            searchName,
        } = this.state;
        const toggleDrawer = (open) => event => {
            if (event && event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
                return;
            }
            this.setState(() => ({
                stateRight: open
            }));
        };
        const showTabPanel = () => {
            if (tabIndex === 0) {
                return <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Client ID</TableCell>
                                <TableCell>First Name</TableCell>
                                <TableCell>Last Name</TableCell>
                                <TableCell>Email</TableCell>
                                <TableCell>Originating Attorney</TableCell>
                                <TableCell>Team</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {iClients.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.individual.id}
                                    </TableCell>
                                    <TableCell>{row.individual.first_name}</TableCell>
                                    <TableCell>{row.individual.last_name}</TableCell>
                                    <TableCell>{row.individual.email}</TableCell>
                                    <TableCell>{this.attorneyInfo(row.handler, "name")}</TableCell>
                                    <TableCell>{this.attorneyInfo(row.handler, "team")}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            <Button disabled={row.state === AUDITED ? true : false} variant="outlined" color="primary" onClick={e => this.handleApproval(e, row)}>Approval</Button>
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {iClients.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={12}
                                    count={total_items}
                                    page={iClients.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            } else if (tabIndex === 1) {
                return <Paper className="tableWapper">
                    <Table stickyHeader className="table">
                        <TableHead>
                            <TableRow role="checkbox">
                                <TableCell>Client ID</TableCell>
                                <TableCell>Name</TableCell>
                                <TableCell>Address</TableCell>
                                <TableCell>Note</TableCell>
                                <TableCell>Others</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {cClients.map(row => (
                                <TableRow key={row.id} role="checkbox">
                                    <TableCell component="th" scope="row">
                                        {row.corporation.id}
                                    </TableCell>
                                    <TableCell>{row.corporation.name}</TableCell>
                                    <TableCell>{row.corporation.address ? row.corporation.address.city : ""}</TableCell>
                                    <TableCell>{row.note}</TableCell>
                                    <TableCell>
                                        <div className="h h-l">
                                            <Button variant="outlined" color="primary" onClick={e => this.handleView(e, row)}>View</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleEdit(e, row)}>Edit</Button>
                                            <Button variant="outlined" color="primary" onClick={e => this.handleApproval(e, row)}>Approval</Button>
                                            <DeleteForeverIcon className="del" onClick={e => this.handleDel(e, row)}></DeleteForeverIcon>
                                        </div>
                                    </TableCell>
                                </TableRow>
                            ))}
                            {cClients.length === 0 && (
                                <TableRow style={{ height: 300 }}>
                                    <TableCell colSpan={12} />
                                </TableRow>
                            )}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    colSpan={12}
                                    count={total_items}
                                    page={cClients.length === 0 ? 0 : page_index - 1}
                                    rowsPerPage={page_size}
                                    SelectProps={{
                                        inputProps: { 'arialabel': 'Rows per page' },
                                        native: true,
                                    }}
                                    onChangePage={this.handleChangePage}
                                    onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                />
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
            }
        }
        return (
            <Root>
                <div className="head h h-t">
                    <PageTitle title="All Processing Clients" subtitle="MANAGEMENT"></PageTitle>
                    {/* <div className="f h h-r">
                        <Button className="btn" variant="contained" color="primary" onClick={this.handleAddClient}>ADD CLIENT</Button>
                    </div> */}
                </div>
                <div>
                    <Tabs
                        value={tabIndex}
                        className="tabs"
                        indicatorColor="primary"
                        textColor="primary"
                        onChange={this.handleChange}
                        aria-label="disabled tabs example"
                        TabIndicatorProps={{ style: { display: "none" } }}
                    >
                        <Tab className={tabIndex === 0 ? "tabSelect" : "tab"} label="Individual" />
                        <Tab className={tabIndex === 1 ? "tabSelect" : "tab"} label="Corporation" />
                    </Tabs>
                </div>
                <div className="tableTool h">
                    <div className="searchWapper h m-20">
                        <div className="search c">
                            <Search />
                        </div>
                        <InputBase
                            placeholder="Search client by name"
                            className="bgW"
                            inputProps={{ 'aria-label': 'Search' }}
                            value={searchName}
                            onChange={this.handleSearch}
                        />
                    </div>
                </div>
                {showTabPanel()}
                <Dialog maxWidth={false} open={open}>
                    <Client
                        handleCreate={this.handleCreate}
                        handleCancel={this.handleCancel}
                        title={dialogTitle}
                        data={dialogData}
                        state={dialogState}
                        ICType={tabIndex}
                    ></Client>
                </Dialog>
                <Drawer anchor="right" open={stateRight} onClose={toggleDrawer(false)}>
                    <div
                        role="presentation"
                        onClick={toggleDrawer(false)}
                        onKeyDown={toggleDrawer(false)}
                    >
                        <SideList
                            handleApply={this.handleApply}
                            data={cClients}
                        ></SideList>
                    </div>
                </Drawer>
                <Toast
                    open={showToast}
                    msg={toastMsg}
                    state={toastState}
                    handleClose={this.handleCloseToast}
                ></Toast>
                <AlertDialog
                    open={showAlert}
                    title="Warning"
                    content="Are you sure to delete this client?"
                    handleAlertYes={this.handleAlertYes}
                    handleAlertNo={this.handleAlertNo}
                ></AlertDialog>
            </Root>
        );
    }
    componentDidMount() {
        this.getClients();
        console.log(this.state.showAlert)
    }
    getClients() {
        const { tabIndex } = this.state;
        if (tabIndex === 0) {
            this.getIClients();
        } else if (tabIndex === 1) {
            this.getCClients();
        }
    }
    getCClients() {
        const { page_index, page_size, searchName } = this.state;
        let params = {
            target: "corp",
            name: searchName,
            state: UNAUDITED,
            page_index,
            page_size
        }
        this.getCClientList(params);
    }
    getIClients() {
        const { page_index, page_size, searchName } = this.state;
        let params = {
            name: searchName,
            state: UNAUDITED,
            page_index,
            page_size
        }
        this.getIClientList(params);
    }
    //tab选项卡
    handleChange(e, newValue) {
        let tabIndex = newValue;
        this.setState({
            tabIndex,
            searchName: "",
            searchEmail: "",
            page_index: 1,
            page_size: 5
        }, () => {
            this.getClients();
        })
    }
    handleAddClient() {
        this.setState(() => ({
            dialogData: null
        }))
        this.openDialog("ADD CLIENT", CLIENT, ADD);
    }
    handleView(e, obj) {
        this.setState(() => ({
            dialogData: obj
        }))
        this.openDialog("VIEW CLIENT", CLIENT, VIEW);
    }
    handleEdit(e, obj) {
        const client_id = obj.id;
        this.setState(() => ({
            dialogData: obj,
            client_id
        }))
        this.openDialog("EDIT CLIENT", CLIENT, EDIT);
    }
    handleApproval(e, obj) {
        const { tabIndex } = this.state;
        e.stopPropagation();
        if (tabIndex === 0) {
            this.iApproval(obj.id);
        } else if (tabIndex === 1) {
            this.cApproval(obj.id);
        }
    }
    handleDel(e, obj) {
        console.log("aa")
        this.setState(() => ({
            dialogData: obj,
            showAlert: true
        }))
    }
    handleCloseDialog() {
        this.closeDialog();
    }
    handleCancel() {
        this.closeDialog();
    }
    handleCreate(radioValue, obj) {
        const { dialogState, client_id } = this.state;
        if (radioValue === INDIVIDUAL) {//个人
            if (dialogState === ADD) {
                this.addIndividual(obj)
            } else if (dialogState === EDIT) {
                this.editIndividual(client_id, obj)
            }
        } else if (radioValue === CORPORATION) {//公司
            if (dialogState === ADD) {
                this.addCorporation(obj)
            } else if (dialogState === EDIT) {
                this.editCorporation(client_id, obj)
            }
        }

    }
    handleSearch(e) {
        const value = e.target.value;
        this.setState({
            searchName: value,
            page_index: 1
        }, () => {
            this.getClients();
        })
    }
    handleApply(obj) {
    }
    handleChangePage(e, newPage) {
        console.log(newPage + 1)
        this.setState({
            page_index: newPage + 1
        }, () => {
            this.getClients();
        })
    }
    handleChangeRowsPerPage(e) {
        const page_size = parseInt(e.target.value, 10);
        this.setState({
            page_index: 1,
            page_size
        }, () => {
            this.getClients();
        });
    }
    showToast(toastMsg, toastState) {
        this.setState(() => ({
            showToast: true,
            toastState,
            toastMsg
        }))
    }
    handleCloseToast() {
        this.setState(() => ({
            showToast: false
        }))
    }
    handleAlertYes() {
        const { tabIndex, dialogData } = this.state;
        if (tabIndex === 0) {
            this.delIndividual(dialogData.id);
        } else if (tabIndex === 1) {
            this.delCorporation(dialogData.id);
        }
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    handleAlertNo() {
        this.setState(() => ({
            showAlert: false,
            currentObj: null
        }));
    }
    closeDialog() {
        this.setState(() => ({
            open: false,
            dialogData: null,
        }));
    }
    openDialog(title, type, state) {
        this.setState(() => ({
            open: true,
            dialogTitle: title,
            dialogState: state,
            dialogType: type,
        }));
    }
    getUserDepartment(teamData) {
        if (teamData) {
            if (teamData !== null && teamData.length > 0) {
                let deptObj = teamData[0].dept;
                let deptName = deptObj.name;
                return deptName
            }
        }
        return "";
    }
    originAttorneyName(obj) {
        if (obj) {
            return obj.username;
        } else {
            return "";
        }
    }
    attorneyInfo(handlerArr, type) {
        if (handlerArr) {
            let attorneyObj = {};
            for (const obj of handlerArr) {
                if (obj.is_origin_attorney) {
                    attorneyObj = obj;
                }
            }
            if (attorneyObj) {
                if (type === "name") {
                    const userObj = attorneyObj.user;
                    return userObj.first_name + " " + userObj.last_name;
                } else if (type === "team") {
                    const teamObj = attorneyObj.team;
                    return teamObj.name;
                }
            }
        }
        return "--";
    }
    editAttorney(client_id, handler, callback) {
        const { dialogData } = this.state;
        console.log(dialogData)
        const addHandler = handler;
        const delHandler = this.extAttorney(dialogData.handler);
        const addHandlerId = addHandler[0].handler_id;
        const delHandlerId = delHandler.handler_id;
        const addTeamId = addHandler[0].handler_team_id;
        const delTeamId = delHandler.handler_team_id;
        if (addHandler && delHandler) {
            if (addHandlerId === delHandlerId && addTeamId === delTeamId) {
                callback();
            } else {
                this.delMembers(client_id, delHandler, () => {
                    this.addMembers(client_id, addHandler, () => {
                        callback();
                    });
                });
            }
        }
    }
    extAttorney(handlers) {
        let handlerObj = {};
        for (const obj of handlers) {
            if (obj.is_origin_attorney) {
                handlerObj.handler_id = obj.user.id;
                handlerObj.handler_team_id = obj.team.id;
                handlerObj.is_origin_attorney = obj.is_origin_attorney;
                return handlerObj;
            }
        }
        return null;
    }
    //---------------request---------------
    getIClientList(params) {
        instance.get(BASE_URL + roleStr() + '/clients', { params }).then((res) => {
            const iClients = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(iClients);
            this.setState(() => ({
                iClients,
                page_size,
                total_items
            }))
        })
    }
    getCClientList(params) {
        instance.get(BASE_URL + roleStr() + '/clients', { params }).then((res) => {
            const cClients = res.data.data;
            const pageObj = res.data.meta;
            const page_size = pageObj.page_size;
            const total_items = pageObj.total_items;
            console.log(cClients);
            this.setState(() => ({
                cClients,
                page_size,
                total_items
            }))
        })
    }
    addIndividual(obj) {
        const params = {
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            related_parties: obj.related_parties,
            note: obj.note,
            handler_id: obj.handler_id,
            handler_team_id: obj.handler_team_id,
        }
        instance.post(BASE_URL + 'admin/clients/individual', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getIClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addCorporation(obj) {
        const params = {
            name: obj.name,
            referral_source: obj.referral_source,
            address: obj.address,
            points_of_contact: obj.points_of_contact,
            related_parties: obj.related_parties,
            note: obj.note,
            members: obj.members,
            handler_id: obj.handler_id,
            handler_team_id: obj.handler_team_id,
        }
        instance.post(BASE_URL + 'admin/clients/corporation', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getCClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    editIndividual(client_id, obj) {
        const params = {
            // related_parties: obj.related_parties,
            first_name: obj.first_name,
            last_name: obj.last_name,
            email: obj.email,
            phone: obj.phone,
            wechat: obj.wechat,
            referral_source: obj.referral_source,
            note: obj.note,
            // handlers: obj.handlers,
        }
        console.log("params", params)
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            this.editAttorney(client_id, obj.handlers, () => {
                this.showToast("Successfully modified", "success");
                this.closeDialog();
                this.getIClients();
                this.setState(() => ({
                    tabIndex: 0
                }));
            });
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    editCorporation(client_id, obj) {
        const params = {
            // referral_source: obj.referral_source,
            // related_parties: obj.related_parties,
            // members: obj.members,
            name: obj.name,
            address: obj.address,
            note: obj.note,
            points_of_contact: obj.points_of_contact,
            // handlers: obj.handlers,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/corporation', params).then((res) => {
            console.log(res)
            this.editAttorney(client_id, obj.handlers, () => {
                this.showToast("Successfully modified", "success");
                this.closeDialog();
                this.getCClients();
                this.setState(() => ({
                    tabIndex: 1
                }));
            });
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delIndividual(client_id) {
        instance.delete(BASE_URL + 'admin/clients/' + client_id + '/individual').then((res) => {
            console.log(res)
            this.showToast("Successfully deleted", "success");
            this.getIClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delCorporation(client_id) {
        instance.delete(BASE_URL + 'admin/clients/' + client_id + '/corporation').then((res) => {
            console.log(res)
            this.showToast("Successfully deleted", "success");
            this.getCClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    iApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        console.log("params", params)
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/individual', params).then((res) => {
            console.log("审核", res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    cApproval(client_id) {
        const params = {
            state: AUDITED,
        }
        instance.put(BASE_URL + roleStr() + '/clients/' + client_id + '/corporation', params).then((res) => {
            console.log(res)
            this.showToast("Added successfully", "success");
            this.closeDialog();
            this.getClients();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    addMembers(client_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.post(BASE_URL + roleStr() + '/clients/' + client_id + '/handlers', params).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
    delMembers(client_id, handlers, callback) {
        let params = {
            handlers
        }
        instance.delete(BASE_URL + roleStr() + '/clients/' + client_id + '/handlers', { data: params }).then((res) => {
            callback();
        }).catch((err) => {
            const msg = err.response.data.message;
            this.showToast(msg, "error");
        })
    }
}

// store映射
const mapStateToProps = (state) => {
    return {
        // iClients: state.getIn(['processinglist', 'iClients']),
        // cClients: state.getIn(['processinglist', 'cClients'])
    }
}
const mapDispathToProps = (dispath) => {
    return {
        // getIClients: (params) => {
        //     dispath(reducer.getIClients(params));
        // },
        // getCClients: (params) => {
        //     dispath(reducer.getCClients(params));
        // }
    }
}

export default connect(mapStateToProps, mapDispathToProps)(ProcessingList);